(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function qsa(sel, el) { return Array.prototype.slice.call((el || d).querySelectorAll(sel)); }
  function onReady(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  /* true the first time for an element; prevents double binding when the theme editor re-runs init */
  function once(el, key) { var a = 'data-lx-init-' + key; if (el.hasAttribute(a)) return false; el.setAttribute(a, ''); return true; }
  function money(v) {
    var n = typeof v === 'string' ? parseFloat(v) : v;
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: (w.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }

  /* reveal */
  function initReveal(scope) {
    var els = qsa('[data-lx-reveal]:not(.is-in),[data-lx-lines]:not(.is-in)', scope);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in w)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* depth: subtle parallax on editorial images (desktop and mobile) */
  var depthEls = [], depthBound = false, depthTick = false;
  function depthUpdate() {
    depthTick = false;
    var vh = w.innerHeight, mob = w.innerWidth < 750, vals = [];
    for (var k = 0; k < depthEls.length; k++) {
      var el = depthEls[k], box = el.parentElement.closest('.lx-depth') || el.parentElement;
      var r = box.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) { vals.push(null); continue; }
      var f = (parseFloat(el.getAttribute('data-lx-parallax')) || 0.07) * (mob ? 0.6 : 1);
      var y = (r.top + r.height / 2 - vh / 2) * -f;
      var lim = r.height * (el.tagName === 'IMG' ? 0.045 : 0.06);
      vals.push(Math.max(-lim, Math.min(lim, y)));
    }
    for (var j = 0; j < depthEls.length; j++) { if (vals[j] !== null) depthEls[j].style.setProperty('--lx-py', vals[j].toFixed(1) + 'px'); }
  }
  function initDepth(scope) {
    if (reduce) return;
    qsa('.lx-edit__media, .lx-rit__visual, .lx-help__media, .lx-uni__card-media, .lx-phero__media, .lx-mani__bg, .lx-coll__media', scope).forEach(function (box) {
      if (!once(box, 'depth')) return;
      var img = box.querySelector('img'); if (!img) return;
      box.classList.add('lx-depth');
      img.setAttribute('data-lx-parallax', box.matches('.lx-phero__media, .lx-mani__bg') ? '0.1' : '0.07');
      if (box.hasAttribute('data-lx-reveal') && !box.matches('.lx-phero__media, .lx-mani__bg')) box.setAttribute('data-lx-reveal', 'mask');
    });
    qsa('[data-lx-parallax]', scope).forEach(function (el) { if (depthEls.indexOf(el) < 0) depthEls.push(el); });
    if (!depthEls.length) return;
    if (!depthBound) {
      depthBound = true;
      w.addEventListener('scroll', function () { if (!depthTick) { depthTick = true; requestAnimationFrame(depthUpdate); } }, { passive: true });
      w.addEventListener('resize', function () { requestAnimationFrame(depthUpdate); });
    }
    depthUpdate();
  }

  /* horizontal scrollers: progress line + one-time swipe hint on touch screens */
  var coarse = w.matchMedia && w.matchMedia('(pointer: coarse)').matches;
  function initScrollers(scope) {
    qsa('.lx-need__products, .lx-feat__grid, .lx-sens__track, .lx-rev__cards, .lx-uni__cards', scope).forEach(function (sc) {
      if (!once(sc, 'scroller')) return;
      var nx = sc.nextElementSibling, bar = nx && nx.classList.contains('lx-progress') ? nx.querySelector('span') : null;
      if (!bar) {
        var pg = d.createElement('div'); pg.className = 'lx-progress lx-progress--auto'; pg.setAttribute('aria-hidden', 'true'); pg.innerHTML = '<span></span>';
        sc.parentNode.insertBefore(pg, sc.nextSibling); bar = pg.querySelector('span');
      }
      var prog = bar.parentElement, tick = false;
      function upd() {
        tick = false;
        var max = sc.scrollWidth - sc.clientWidth, on = max > 6;
        prog.classList.toggle('is-off', !on);
        if (!on) return;
        var ratio = sc.clientWidth / sc.scrollWidth;
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + ((sc.scrollLeft / max) * (1 / ratio - 1) * 100) + '%)';
      }
      sc.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      w.addEventListener('resize', upd);
      qsa('img', sc).forEach(function (im) { if (!im.complete) im.addEventListener('load', upd, { once: true }); });
      upd();
      if (!reduce && coarse && 'IntersectionObserver' in w) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            if (sc.scrollLeft < 4 && sc.scrollWidth - sc.clientWidth > 6) {
              sc.classList.add('lx-nudge');
              setTimeout(function () { sc.classList.remove('lx-nudge'); }, 1700);
            }
          });
        }, { threshold: 0.6 });
        io.observe(sc);
      }
    });
  }

  /* announcement */
  function initAnnouncement() {
    qsa('[data-lx-ann]').forEach(function (bar) {
      if (!once(bar, 'ann')) return;
      var msgs = qsa('.lxh-ann__msg', bar);
      if (msgs.length < 2 || reduce) return;
      var i = 0, paused = false;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || d.hidden) return;
        msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
      }, 4800);
    });
  }

  /* header */
  function initHeader() {
    var h = d.querySelector('.lxh');
    if (!h || !once(h, 'header')) return;
    var wrap = h.closest('.lxh-wrap') || h;
    var scrim = d.querySelector('.lxh-scrim');
    var overlay = h.classList.contains('lxh--overlay');
    var lastY = w.scrollY, hideEnabled = h.hasAttribute('data-hide-on-scroll');
    function setH() { root.style.setProperty('--lxh-h', h.querySelector('.lxh__bar').offsetHeight + 'px'); }
    setH(); w.addEventListener('resize', setH);
    function onScroll() {
      var y = w.scrollY;
      if (overlay) h.classList.toggle('is-solid', y > 24);
      if (hideEnabled && !h.classList.contains('is-open') && !d.querySelector('.lxd.is-open')) {
        if (y > 480 && y > lastY + 6) h.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 200) h.classList.remove('is-hidden');
      }
      lastY = y;
    }
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var items = qsa('.lxh__item[data-mega]', h);
    var openItem = null, closeT = null, openT = null;
    function setScrim(on) { if (scrim) scrim.classList.toggle('is-on', on); }
    function close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var b = item.querySelector('.lxh__link'); if (b) b.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
      if (!openItem && !h.classList.contains('is-searching')) { h.classList.remove('is-open'); setScrim(false); }
    }
    function open(item) {
      if (openItem && openItem !== item) close(openItem);
      openItem = item; item.classList.add('is-open'); h.classList.add('is-open'); setScrim(true);
      var b = item.querySelector('.lxh__link'); if (b) b.setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (item) {
      var link = item.querySelector('.lxh__link');
      if (finePointer) {
        item.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function () { open(item); }, openItem ? 0 : 140); });
        item.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { close(item); }, 220); });
      }
      link.addEventListener('click', function (e) {
        if (item.classList.contains('is-open') && finePointer) return;
        e.preventDefault();
        if (item.classList.contains('is-open')) close(item); else open(item);
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(item); });
    });
    if (scrim) scrim.addEventListener('click', function () { if (openItem) close(openItem); closeSearch(); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openItem) { var l = openItem.querySelector('.lxh__link'); close(openItem); if (l) l.focus(); }
      closeSearch(); closeDrawer();
    });

    /* search */
    var panel = d.getElementById('LxSearch');
    var input = panel && panel.querySelector('.lxs__input');
    var results = panel && panel.querySelector('[data-lx-results]');
    var opener = null, ctrl = null, timer = null;
    function openSearch(btn) {
      if (!panel) return;
      opener = btn || null;
      if (openItem) close(openItem);
      panel.hidden = false; h.classList.add('is-open', 'is-searching'); setScrim(true);
      qsa('[data-lx-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { input && input.focus(); }, 30);
    }
    function closeSearch() {
      if (!panel || panel.hidden) return;
      panel.hidden = true; h.classList.remove('is-searching');
      if (!openItem) { h.classList.remove('is-open'); setScrim(false); }
      qsa('[data-lx-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener) opener.focus();
    }
    qsa('[data-lx-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (panel && !panel.hidden) closeSearch(); else openSearch(b); }); });
    qsa('[data-lx-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    function render(products, q) {
      if (!results) return;
      if (!products.length) { results.innerHTML = '<p class="lxs__empty">' + (results.getAttribute('data-empty') || 'Sin resultados') + ' «' + q.replace(/[<>&"]/g, '') + '».</p>'; return; }
      results.innerHTML = '<div class="lxs__results">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        var alt = (p.featured_image && p.featured_image.alt) || p.title;
        return '<a class="lxs__res" href="' + p.url + '"><span class="lx-media">' + (img ? '<img src="' + img + '" alt="' + String(alt).replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">' : '') + '</span>' + p.title + '<span class="lxs__res-price">' + money(p.price) + '</span></a>';
      }).join('') + '</div>';
    }
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { if (results) results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          if (ctrl && ctrl.abort) ctrl.abort();
          ctrl = 'AbortController' in w ? new AbortController() : null;
          var base = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (j) { render((j.resources && j.resources.results && j.resources.results.products) || [], q); })
            .catch(function () {});
        }, 220);
      });
    }

    /* drawer */
    var drawer = d.getElementById('LxDrawer');
    var burger = h.querySelector('.lxh__burger');
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); root.classList.add('lx-lock');
      burger && burger.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('.lxd__close'); setTimeout(function () { c && c.focus(); }, 60);
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); root.classList.remove('lx-lock');
      burger && burger.setAttribute('aria-expanded', 'false'); burger && burger.focus();
    }
    burger && burger.addEventListener('click', openDrawer);
    if (drawer) {
      qsa('[data-lx-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      qsa('.lxd__top[aria-controls]', drawer).forEach(function (b) {
        b.addEventListener('click', function () { b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); });
      });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = qsa('a[href],button:not([disabled]),input', drawer.querySelector('.lxd__panel')).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }
    w.lxCloseOverlays = function () { closeSearch(); closeDrawer(); if (openItem) close(openItem); };
  }

  /* hero */
  function initHero() {
    qsa('[data-lx-hero]').forEach(function (hero) {
      if (!once(hero, 'hero')) return;
      /* the copy fades in once and then stays put: no transitions left on it while the video loops */
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-ready'); }); });
      setTimeout(function () { hero.classList.add('is-ready', 'is-settled'); }, 1900);
      if ('IntersectionObserver' in w) {
        new IntersectionObserver(function (en) { root.classList.toggle('lx-hero-view', en[0].isIntersecting); }, { threshold: 0.35 }).observe(hero);
      }
      var v = hero.querySelector('video[data-lx-video]');
      if (!v) return;
      var saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
      if (reduce || saveData) return;
      var mobile = w.matchMedia('(max-width: 989px) and (orientation: portrait)').matches;
      var src = (mobile && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src-desktop') || v.getAttribute('data-src-mobile');
      if (!src) return;
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var poster = hero.querySelector('.lx-hero__poster');
      v.addEventListener('playing', function () {
        v.classList.add('is-playing');
        /* only when the video covers the poster (full layout), after its 1.6s fade: avoids a visible scale snap */
        if (poster && v.closest('.lx-hero__media')) setTimeout(function () { poster.classList.remove('lx-kenburns'); }, 1700);
      }, { once: true });
      function start() { v.src = src; v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if (d.readyState === 'complete') setTimeout(start, 250); else w.addEventListener('load', function () { setTimeout(start, 250); });
      if ('IntersectionObserver' in w) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (!v.src) return; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: 0.05 }).observe(hero);
      }
    });
  }

  /* needs selector */
  function initNeeds() {
    qsa('[data-lx-need]').forEach(function (sec) {
      if (!once(sec, 'need')) return;
      var items = qsa('.lx-need__item', sec);
      var grid = sec.querySelector('.lx-need__grid');
      var desktop = w.matchMedia('(min-width: 990px)');
      function size() {
        if (!grid) return;
        if (!desktop.matches) { grid.style.removeProperty('--lx-need-h'); return; }
        var list = sec.querySelector('.lx-need__list');
        var act = sec.querySelector('.lx-need__item.is-active .lx-need__panel');
        var hgt = Math.max(list ? list.offsetHeight : 0, act ? act.scrollHeight : 0);
        grid.style.setProperty('--lx-need-h', hgt + 'px');
      }
      function activate(item, focus) {
        items.forEach(function (it) {
          var on = it === item;
          if (!desktop.matches && on && it.classList.contains('is-active') && !focus) on = false;
          it.classList.toggle('is-active', on);
          var t = it.querySelector('.lx-need__trigger'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
          var p = it.querySelector('.lx-need__panel'); if (p) p.setAttribute('aria-hidden', on ? 'false' : 'true');
          qsa('a,button', p).forEach(function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
        });
        setTimeout(size, 30);
      }
      items.forEach(function (it, idx) {
        var t = it.querySelector('.lx-need__trigger');
        t.addEventListener('click', function () { activate(it, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown') n = items[(idx + 1) % items.length];
          if (e.key === 'ArrowUp') n = items[(idx - 1 + items.length) % items.length];
          if (n) { e.preventDefault(); n.querySelector('.lx-need__trigger').focus(); if (desktop.matches) activate(n, true); }
        });
        if (finePointer) t.addEventListener('mouseenter', function () { if (desktop.matches) activate(it, true); });
      });
      var first = sec.querySelector('.lx-need__item.is-active') || items[0];
      if (first) activate(first, true);
      w.addEventListener('resize', size);
      qsa('img', sec).forEach(function (im) { im.addEventListener('load', size); });
      desktop.addEventListener && desktop.addEventListener('change', function () { var a = sec.querySelector('.lx-need__item.is-active') || items[0]; activate(a, true); });
    });
  }

  /* horizontal tracks */
  function initTracks() {
    qsa('[data-lx-track]').forEach(function (wrap) {
      if (!once(wrap, 'track')) return;
      var track = wrap.querySelector('[data-lx-track-el]');
      if (!track) return;
      var prev = wrap.querySelector('[data-lx-prev]'), next = wrap.querySelector('[data-lx-next]');
      var bar = wrap.querySelector('.lx-progress span');
      function step() { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 20 : track.clientWidth * 0.8; }
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) { var ratio = track.clientWidth / Math.max(track.scrollWidth, 1); bar.style.width = (ratio * 100) + '%'; bar.style.transform = 'translateX(' + ((max ? track.scrollLeft / max : 0) * (1 / ratio - 1) * 100) + '%)'; }
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      w.addEventListener('resize', upd); upd();
    });
  }

  /* reviews */
  function initReviews() {
    qsa('[data-lx-reviews]').forEach(function (sec) {
      if (!once(sec, 'rev')) return;
      var qs = qsa('.lx-rev__q', sec), dots = qsa('.lx-rev__dot', sec);
      if (qs.length < 2) return;
      var i = 0, timer = null, hover = false;
      function go(n) {
        qs[i].classList.remove('is-active'); qs[i].setAttribute('aria-hidden', 'true'); if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
        i = (n + qs.length) % qs.length;
        qs[i].classList.add('is-active'); qs[i].setAttribute('aria-hidden', 'false'); if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
      }
      dots.forEach(function (dt, n) { dt.addEventListener('click', function () { go(n); restart(); }); });
      var pv = sec.querySelector('[data-lx-prev]'), nx = sec.querySelector('[data-lx-next]');
      pv && pv.addEventListener('click', function () { go(i - 1); restart(); });
      nx && nx.addEventListener('click', function () { go(i + 1); restart(); });
      function restart() { clearInterval(timer); if (reduce) return; timer = setInterval(function () { if (!hover && !d.hidden) go(i + 1); }, 7000); }
      sec.addEventListener('mouseenter', function () { hover = true; }); sec.addEventListener('mouseleave', function () { hover = false; });
      sec.addEventListener('focusin', function () { hover = true; }); sec.addEventListener('focusout', function () { hover = false; });

      var stage = sec.querySelector('.lx-rev__stage'), sx = null, sy = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? i + 1 : i - 1); restart(); }
        }, { passive: true });
      }
      restart();
    });
  }

  /* tabs */
  function initTabs() {
    qsa('[data-lx-tabs]').forEach(function (sec) {
      if (!once(sec, 'tabs')) return;
      var tabs = qsa('[role="tab"]', sec);
      function sel(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
          var p = d.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
        if (focus) t.focus();
        initReveal(sec);
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); sel(tabs[(n + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); sel(tabs[(n - 1 + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* universe */
  function initUniverse() {
    qsa('[data-lx-uni]').forEach(function (sec) {
      if (!once(sec, 'uni')) return;
      var imgs = qsa('.lx-uni__frame img', sec), caps = qsa('[data-lx-uni-cap]', sec), chapters = qsa('.lx-uni__chapter', sec);
      if (!imgs.length || !('IntersectionObserver' in w)) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          var n = parseInt(e.target.getAttribute('data-index'), 10) || 0;
          imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === n); });
          caps.forEach(function (c, k) { c.hidden = k !== n; });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      chapters.forEach(function (c) { io.observe(c); });
    });
  }

  /* lazy ambient videos */
  function initLazyVideo(scope) {
    var vids = qsa('video[data-lx-lazyvideo]:not([data-lx-bound])', scope);
    if (!vids.length || reduce || !('IntersectionObserver' in w)) return;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (saveData) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src) { v.src = v.getAttribute('data-src'); v.muted = true; v.addEventListener('playing', function () { v.style.opacity = 1; }, { once: true }); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.src) v.pause();
      });
    }, { rootMargin: '120px 0px', threshold: 0.2 });
    vids.forEach(function (v) { v.setAttribute('data-lx-bound', ''); v.style.opacity = 0; v.style.transition = 'opacity 1s'; io.observe(v); });
  }

  /* Klaviyo sign-up popup (theme-side only, Klaviyo settings untouched): it stays hidden until
     18 s into the visit or ~35 % of the page has been scrolled; tracking keeps running as usual */
  function initKlaviyoGate() {
    if (root.classList.contains('lx-kl-ok')) return;
    var KEY = 'lx-kl-t0', t0, done = false;
    function open() {
      if (done) return; done = true;
      root.classList.add('lx-kl-ok');
      w.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      var max = d.documentElement.scrollHeight - w.innerHeight;
      if (max > 0 && (w.pageYOffset || d.documentElement.scrollTop) / max >= 0.35) open();
    }
    try { t0 = parseInt(sessionStorage.getItem(KEY), 10); if (!t0) { t0 = Date.now(); sessionStorage.setItem(KEY, String(t0)); } } catch (e) { t0 = Date.now(); }
    var left = 18000 - (Date.now() - t0);
    if (left <= 0) { open(); return; }
    setTimeout(open, left);
    w.addEventListener('scroll', onScroll, { passive: true });
    /* tag the secondary button ("Ahora no") so the stylesheet can draw it as an outline */
    function tag() {
      qsa('[class*="kl-private-reset-css-"] .klaviyo-form-button').forEach(function (b) {
        if (/^(ahora no|no,? gracias|no gracias|cerrar|no thanks)/i.test((b.textContent || '').trim())) b.classList.add('lx-kl-secondary');
      });
    }
    if ('MutationObserver' in w) {
      var tick = false;
      new MutationObserver(function () { if (!tick) { tick = true; setTimeout(function () { tick = false; tag(); }, 120); } }).observe(d.body, { childList: true, subtree: true });
    }
  }

  function init() {
    initKlaviyoGate(); initDepth(); initScrollers(); initReveal(); initAnnouncement(); initHeader(); initHero(); initNeeds(); initTracks(); initReviews(); initTabs(); initUniverse(); initLazyVideo();
  }
  onReady(init);
  d.addEventListener('shopify:section:load', function (e) { initDepth(e.target); initScrollers(e.target); initReveal(e.target); initAnnouncement(); initHeader(); initNeeds(); initTracks(); initReviews(); initTabs(); initUniverse(); initHero(); initLazyVideo(e.target); });
})();
